import React, { useState } from "react";
import PropTypes from "prop-types";
import { ChevronRight } from "lucide-react";
import { ReactMarkdownWithGFMPlugin } from "@/utils";

const EMPTY_REHYPE_PLUGINS = [];

export const ActivityThoughtRow = ({ thought, t }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!thought || typeof thought !== "object") return null;

  const displayTitle =
    thought.title ||
    (t ? t("assistant.thinking", "Thinking...") : "Thinking...");

  const hasBody = Boolean(thought.body && thought.body.trim().length > 0);

  return (
    <div className="elelem-activity-thought-container" data-testid="copilot-activity-thought">
      <button
        type="button"
        className={`elelem-activity-thought-row ${hasBody ? "interactive" : ""} ${isExpanded ? "expanded" : ""}`}
        onClick={() => hasBody && setIsExpanded((prev) => !prev)}
        disabled={!hasBody}
        aria-expanded={hasBody ? isExpanded : undefined}
      >
        <span className="elelem-activity-thought-prefix" aria-hidden="true">✦</span>
        <span className="elelem-activity-thought-title">{displayTitle}</span>
        {hasBody && (
          <ChevronRight
            size={11}
            className={`elelem-activity-chevron ms-1 ${isExpanded ? "open" : ""}`}
            aria-hidden="true"
          />
        )}
      </button>

      {isExpanded && hasBody && (
        <div className="elelem-activity-thought-body" data-testid="copilot-thought-body">
          <ReactMarkdownWithGFMPlugin
            rehypePlugins={EMPTY_REHYPE_PLUGINS}
            skipHtml
          >
            {thought.body}
          </ReactMarkdownWithGFMPlugin>
        </div>
      )}
    </div>
  );
};

ActivityThoughtRow.propTypes = {
  thought: PropTypes.shape({
    step: PropTypes.number,
    title: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
  t: PropTypes.func,
};
